module.exports = __webpack_public_path__ + "static/media/logo.dc401a86.svg";